import { IntegrationLogoBox } from "@/integrations";

export default function IntegrationCellTitle(props: {
  integrationId: string;
  connectionLabel?: string;
}) {
  return (
    <div className="flex items-center whitespace-nowrap">
      <IntegrationLogoBox
        id={props.integrationId}
        size="xs"
        className="mr-1.5"
      />
      <div>{props.connectionLabel || props.integrationId}</div>
    </div>
  );
}
